<template>
  <div>
    <portal to='components-main-modal'>
      <pbc-modal class="modal-background fixed top-0 bottom-0"
                title=''
                :enable-background='false'
                @done='$emit("close")'
                @close='$emit("close")'
                :disable-title='true'
                :show-cancel='false' >
        <template #controls='{close,done}'>
          <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
            <pbc-button :disabled='!hasUndos' @click='$emit("undo")'><undo />Undo</pbc-button>
            <pbc-button :disabled='!hasRedos' @click='$emit("redo")'><redo /></pbc-button>
            <pbc-button @click="done" ><check />Done</pbc-button>
            <pbc-button v-if='showPreviewButton' @click="$emit('preview')" class="pbc-primary-color"><play />Preview</pbc-button>
          </div>
        </template>
        <template>
          <component-graph-renderer ref='componentRenderer'
                                    class="h-full"
                                  :transforms-and-source='transformsAndSource'
                                  :transform='transform'
                                  :parent-transform='parentTransform'
                                  :partutil='partutil'
                                  :treeutil='treeutil'
                                  :initial-edit-component='initialEditComponent'
                                  :child-component='childComponent'
                                  @remove='remove'
                                  @add='add'>

            <!--
          <template #after='{component}'>
            <div>
              <recommender :gamedata='partutil.gamedata'
                          :partutil='partutil'  
                          :component='component'
                          :transform='transform'
                          @add-recommendation='addRecommendation'
                          @add='add'
                          @preview='previewRecommender'
                          />
            </div>
          </template>
            -->

          <template #editing='data'>
            <portal to='component-edit-modal'>
              <pbc-modal title='' @done='doneEditing(data)' @close='closeEditing' :enable-background='false'>
                <template #default=''>
                  <component-details :component='data.shadowComponent'
                    :transform='transform'
                    :transforms-and-source='transformsAndSource'
                    :partutil='partutil'
                    :is-selected-component='data.isSelectedComponent'
                    @add='add'
                    @remove='remove'
                    @move-to='data.moveTo'>
                    <template #recommend='{}'>
                      <recommender-links :gamedata='partutil.gamedata'
                        :partutil='partutil'
                        :component='data.component'
                        :transform='transform'
                        :short='true'
                        @select='addLinkRecommendations(data, $event)'
                        />
                    </template>
                  </component-details>

                  <slot name="editing" v-bind='data' />
                </template>
                <template #controls='{close,done}'>
                  <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
                    <pbc-button @click="done" ><check />Done</pbc-button>
                    <pbc-button v-if='isAdvancedMode' @click="preview(data)" ><play />Preview</pbc-button>
                  </div>
                </template>
              </pbc-modal>
            </portal>
          </template>
        </component-graph-renderer>

          <!--
        <component-renderer ref='componentRenderer' 
          :transforms-and-source='transformsAndSource'
          :transform='transform'
          :partutil='partutil'
          :treeutil='treeutil'
          :initial-edit-component='initialEditComponent'
          @remove='remove'
          @add='add'
          @close='$emit("close")'
          @change-editing-component='onChangeEditingComponent'>
          <template #after='{component}'>
            <div class="border">
              <recommender :gamedata='partutil.gamedata'
                          :partutil='partutil'  
                          :component='component'
                          :transform='transform'
                          @add-recommendation='addRecommendation'
                          @add='add'
                          @preview='previewRecommender'
                          />
            </div>
          </template>
          <template #editing='data'>
            <portal to='component-edit-modal'>
              <pbc-modal title='' @done='doneEditing(data)' @close='closeEditing'>
                <template #default=''>
                  <component-details :component='data.shadowComponent'
                    :transform='transform'
                    :transforms-and-source='transformsAndSource'
                    :partutil='partutil'
                    :is-selected-component='data.isSelectedComponent'
                    @add='add'
                    @remove='remove'
                    @move-to='data.moveTo'>
                    <template #recommend='{}'>
                      <recommender-links :gamedata='partutil.gamedata'
                        :partutil='partutil'
                        :component='data.component'
                        :transform='transform'
                        :short='true'
                        @select='addLinkRecommendations(data, $event)'
                        />
                    </template>
                  </component-details>

                  <slot name="editing" v-bind='data' />
                </template>
                <template #controls='{close,done}'>
                  <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
                    <pbc-button @click="done" ><check />Done</pbc-button>
                    <pbc-button @click="preview(data)" ><play />Preview</pbc-button>
                  </div>
                </template>
              </pbc-modal>
            </portal>
          </template>
        </component-renderer>
          -->
        </template>
      </pbc-modal>

    </portal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import getChildComponent from '@edit/tree/funkies.js';
import Recommender from '@ui/organisms/Recommender.vue';
import RecommenderLinks from '@ui/organisms/RecommenderLinks.vue';
import Play from '@icons/Play.vue';
import Check from '@icons/Check.vue';
import Treeutil from '@edit/tree/treeutil.js';
import { cloneDeep, debounce, isEqual } from 'lodash';
import ComponentRenderer from '@edit/molecules/ComponentRenderer.vue';
import ComponentGraphRenderer from '@edit/organisms/ComponentGraphRenderer.vue';
import ComponentDetails from '@ui/molecules/ComponentDetails.vue';
import Undo from '@icons/Undo.vue';
import Redo from '@icons/Redo.vue';

export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    selectionsData:{
      type: Array,
      required: true
    },
    initialEditComponent: {
      type: Object,
      required: false
    },
    hasUndos: {
      type: Boolean,
      default: false
    },
    hasRedos: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addRecommendation({addedComponents, addedLinks}) {
      this.$emit('add-recommendation', {
        addedComponents,
        addedLinks
      });
      this.showPreviewButton = true;
      this.$ana.track({
        eventCategory:'recommendation',
        eventAction:'addRecommendation'
      });
      setTimeout( () => {
        this.$eventbus.emit('addRecommendation');
      }, 200);
    },
    preview({component,shadowComponent}) {
      Object.assign(component, shadowComponent);
      this.$emit('preview');
    },
    previewRecommender() {
      this.$emit('preview');
    },
    add({component}) {
      console.log('lol', component);
      this.$ana.track({
        eventCategory:'recommendation',
        eventAction:'addRecommendation',
        extra: {
          parent: component.type
        }
      });

      const activeSelections = this.selectionsData.filter( (sd) => {
        return !sd.indirectlySelected;
      });

      console.log('add component', activeSelections.length);
      if (activeSelections.length) {
        const transforms = activeSelections.map( ({transform}) => {
          return transform;
        });
        this.$emit('add', {
          parents: [component],
          transforms
        });
      }
      this.showPreviewButton = true;
    },
    remove({component}) {
      this.showPreviewButton = true;
      if (this.editingComponent && this.editingComponent.id === component.id) {
        this.editingComponent = null;
      }
      const {components,links} = this.transformsAndSource.from;
      const treeutil = new Treeutil({
        components,
        links
      });
      const {removedComponents, removedLinks} = treeutil.removeComponent(component);
      console.log('emit remove');
      this.$emit('remove', {
        removedComponents,
        removedLinks,
      });
      //this._calculateComponentsAndLinks();
      
    },
    onChangeEditingComponent(component) {
      this.$emit("change-editing-component", component);
      this.editingComponent = component;
    },
    _calculateComponentsAndLinks() {
      const {components, links} = this.partutil.findComponentsAndLinksFrom(this.component);
      this.treeutil = new Treeutil({
        components,
        links
      });
      this.components = components;
      this.links = links;
    },
    forceSelectComponent({component}) {
      this.$refs.componentRenderer.select(component);
    },
    forceMoveToComponent({component}) {
      this.$refs.componentRenderer.moveTo({component});
    },
    closeEditing() {
      this.$refs.componentRenderer.close({});
    },
    doneEditing({component,shadowComponent}) {
      const nv = cloneDeep(shadowComponent);
      const ov = cloneDeep(component);
      this.$emit('change', {
        nv,
        ov,
        transform:this.transform
      });

      Object.assign(component, shadowComponent);
      this.$refs.componentRenderer.close({});
      
      if (!isEqual(nv, ov)) {
        this.showPreviewButton = true;
      }

      if ((this.initialEditComponent||{}).id === component.id) {
        this.$emit('close');
      }
    },
    addLinkRecommendations({component,moveTo}, link) {
      const addedComponents = [component]
      this.$emit('add-link-recommendation', {link,addedComponents});
      moveTo({component});
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const calculateComponentsAndLinks = debounce(this._calculateComponentsAndLinks, 50);
    const {components, links} = this.partutil.findComponentsAndLinksFrom(component);
    const treeutil = new Treeutil({
      components,
      links
    });
    const parents = this.partutil.getParentsForTransform(this.transform);
    console.log('have parents', parents);
    const parentTransform = parents[0];
    console.log('have parentTransform', parentTransform);
    let childComponent;
    if (parentTransform) {
      const parentComponent = this.partutil.findComponentForTransform(parentTransform);
      childComponent = getChildComponent(parentComponent);
    }
    console.log('have childComponent', childComponent);
    //const parentTransform = 
    return {
      component,
      treeutil,
      components,
      links,
      calculateComponentsAndLinks,
      editingComponent: null,
      showPreviewButton: false,
      parentTransform,
      childComponent
    }
  },
  components:{
    //ComponentRenderer,
    ComponentGraphRenderer,
    ComponentDetails,
    Play,
    Check,
    Undo,
    Redo,
    //Recommender,
    RecommenderLinks
  },
  watch: {
    'transformsAndSource.from.links.length': {
      handler() {
        this.calculateComponentsAndLinks();
      },
      immediate: true
    },
    'transformsAndSource.from.components.length': {
      handler() {
        this.calculateComponentsAndLinks();
      },
      immediate: true
    },
    'transform.vars':{
      handler() {
        this.showPreviewButton = true;
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.$emit("change-editing-component", null);
  },
  computed: {
    ...mapState(['isAdvancedMode'])
  }
}
</script>
